import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className={`sidebar shadow-sm ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header d-flex justify-content-between align-items-center px-3 py-2 bg-primary text-white">
        <span>{collapsed ? '⚙️' : 'Admin Panel'}</span>
        <button className="btn btn-sm btn-light" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? '➡️' : '⬅️'}
        </button>
      </div>

      <Nav.Item>
        <Link to="/admin" className={`nav-link mt-4 d-flex align-items-center gap-2 ${location.pathname === "/admin" ? "active" : ""}`}>
          <span className="sidebar-icon">📊</span>
          {!collapsed && <span>Dashboard</span>}
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link to="/chatlogs" className={`nav-link d-flex align-items-center gap-2 ${location.pathname === "/chatlogs" ? "active" : ""}`}>
          <span className="sidebar-icon">💬</span>
          {!collapsed && <span>Chat Logs</span>}
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link to="/stats" className={`nav-link d-flex align-items-center gap-2 ${location.pathname === "/stats" ? "active" : ""}`}>
          <span className="sidebar-icon">📈</span>
          {!collapsed && <span>Analytics</span>}
        </Link>
      </Nav.Item>

      <Nav.Item>
        <Link to="/instruct" className={`nav-link d-flex align-items-center gap-2 ${location.pathname === "/instruct" ? "active" : ""}`}>
          <span className="sidebar-icon">🧠</span>
          {!collapsed && <span>Instruct AI</span>}
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link to="/branding" className={`nav-link d-flex align-items-center gap-2 ${location.pathname === "/branding" ? "active" : ""}`}>
          <span className="sidebar-icon">🛣️</span>
          {!collapsed && <span>Brand AI</span>}
        </Link>
      </Nav.Item>
      <Nav.Item>
          <Link to="/widgets" className={`nav-link ${location.pathname === "/widgets" ? "active" : ""}`}>
            🧩 {collapsed ? '' : 'Widgets'}
          </Link>
        </Nav.Item>

        <Nav.Item>
        <Link to="/train-url" className={`nav-link ${location.pathname === "/train-url" ? "active" : ""}`}>
          🌐 {collapsed ? "" : "Train via URL"}
        </Link>
      </Nav.Item>

      <Nav.Item className="mt-auto pt-3">
        <button className="btn btn-outline-danger w-100 d-flex align-items-center gap-2" onClick={handleLogout}>
          <span className="sidebar-icon">🚪</span>
          {!collapsed && <span>Logout</span>}
        </button>
      </Nav.Item>




    </div>
  );
};

export default Sidebar;
